import React from "react";
import NumberFormat from "react-number-format";
import { Label } from "../../../../../../library/label";

const Index = ({ shareholder, last }) => {
  return (
    <tr id={shareholder.id} className={last ? "bottom" : ""}>
      <td>
        <Label version={1} weight="bold">
          {shareholder.name ? shareholder.name : "Utilgjengelig"}
        </Label>
      </td>
      <td>
        <Label version={2} weight="regular">
          {shareholder.organizationNumber ? (
            <NumberFormat
              format={"### ### ###"}
              displayType="text"
              value={shareholder.organizationNumber}
            />
          ) : (
            "Utilgjengelig"
          )}
        </Label>
      </td>
      <td>
        <Label version={2} weight="regular">
          {shareholder.country ? shareholder.country : "Utilgjengelig"}
        </Label>
      </td>
      <td>
        <Label version={2} weight="regular">
          {shareholder.share ? `${shareholder.share}%` : "Utilgjengelig"}
        </Label>
      </td>
    </tr>
  );
};

export default Index;
